import React, { HTMLProps, useRef } from "react";
import { useProductImpressionTracking } from "./useProductImpressionTracking";
export const TrackedCarouselItem = (props: HTMLProps<HTMLLIElement>) => {
  const liRef = useRef<HTMLLIElement>(null);
  useProductImpressionTracking(liRef);
  const {
    children,
    ...rest
  } = props;
  return <li {...rest} ref={liRef} data-sentry-component="TrackedCarouselItem" data-sentry-source-file="TrackedCarouselItem.tsx">
      {children}
    </li>;
};